import React, { Component } from 'react';

import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';
import AddressField from '../elements/AddressField';

import { Details as styles } from './form.css';
import Config from '../../conf';
import DatePicker from 'material-ui/DatePicker';
import CustomTimePicker from '../elements/CustomTimePicker';
import moment from 'moment';
import Util from '../../Util';
import DropDownMenu from 'material-ui/DropDownMenu';

const washTypes = Config.WASH_TYPES;

class Details extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      bookButtonDisabled: false,
      error: false,

      bookingCompleted: false
    };
    this.keyTyped = this.keyTyped.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.fieldChanged = this.fieldChanged.bind(this);
    this.sendToBackend = this.sendToBackend.bind(this);
    this.retry = this.retry.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
  }

  sendToBackend(body) {
    // set to loading mode
    this.setState({
      loading: true
    });
    return new Promise((resolve, reject) => {
      fetch(Config.BACKEND_API_URL + 'carpark/create', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
        return response.json().then(data => {
          if (data.status === 200) {
            resolve();
          } else {
            throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
          }
        });
      }).catch(err => {
        reject(err);
      });
    });
  }

  fieldChanged(fieldName, newValue) {
    this.props.setHasError(fieldName, false);
    this.props.updateField(fieldName, newValue);
  }

  nextDisabled() {
    let ret = !this.props.details.name ||
      !this.props.details.phone ||
      !this.props.details.date ||
      !this.props.details.startTime;

    return ret;
  }

  keyTyped(field, value) {
    this.props.setHasError(field, false);
    this.props.updateField(field, value);
  }

  setWashType(ev, washTypeIndex, washTypeName) {
    const washTypeTmp = JSON.parse(JSON.stringify(washTypes));
    const washType = washTypeTmp.filter(function (wash) {
      return wash.name === washTypeName;
    })[0];
    this.props.updateField('washType', washType.name.replace(/[^a-zA-Z]/g, ''));
    this.props.updateField('washTypeDisplay', washType.displayName);

    let extraWashPrice = 0;
    if (this.props.details.carType.toUpperCase() === 'SUV') {
      extraWashPrice = 10;
    } else if (this.props.details.carType.toUpperCase() === 'VAN') {
      extraWashPrice = 20;
    }
    this.props.updateField('washPrice', this.props.details.washDetails[washType.name].cost + (extraWashPrice));
  }

  retry() {
    this.setState({
      bookButtonDisabled: false,
      loading: false,
      error: false
    });
    this.confirmClicked();
  }
  
  refreshPage() {
    location.reload();
  }
  
  confirmClicked(washType) {
    this.props.details.washType = washType;
    const body = {
      name: this.props.details.name,
      email: this.props.details.phone,
      phone: this.props.details.phone,
      numberPlate: this.props.details.phone,
      date: this.props.details.date,
      startTime: this.props.details.startTime,
      address: '320 Melton Rd, Northgate QLD 4013',
      carType: 'sedan',
      washType: this.props.details.washType,
      notes: this.props.details.notes,
      platform: 'white',
      whiteLabel: Config.CLIENT_NAME,
      prefix: Config.CLIENT_NAME,
      clientId: Config.CLIENT_ID
    };
    this.sendToBackend(body).then(() => {
      this.setState({
        bookingCompleted: true
      });
      window.location = '/payment/' + this.props.details.phone;
    }).catch(err => {
      this.setState({
        error: true
      });
      console.log('Failed to send to backend: ' + err);
    });
  };

  shouldDisableDate(date) {
    const minDate = moment(moment().format('YYYY-MM-DD'));
    const maxDate = minDate.clone().add(1, 'month').subtract(1, 'day');

    const momentDate = moment(date);
  
    let valid = true;

    if (momentDate.isBefore(minDate)) valid = false;
    if (momentDate.isAfter(maxDate)) valid = false;
    
    // Should disable date ie. if it is valid then it should not be disabled
    return !valid;
  }

  formatDate(date) {
    if (!date) return '';
    return Util.monthToString(date.getMonth()) + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  updateDate(fieldName, newValue) {
    this.state.startTimes = [];
    for (let time = 9; time < 18; time ++){
      this.state.startTimes.push(time);
    }
    this.fieldChanged('startTime', '');
    this.fieldChanged(fieldName, newValue);
  }

  handleStartTimeChange(evt, idx, val) {
    if (!val)
      return;  

    this.props.updateField('startTime', val);
  }  

  format(time) {
    const momentFormat = 'h:mm a';
    
    const startHour = Math.floor(time);
    const startMinutes = (time - startHour) * 60;

    const startFomatted = moment().hours(startHour).minutes(startMinutes).format(momentFormat);

    return startFomatted; 
  }
  
  render() {
    let extraWashPrice = 0;
    if (this.props.details.carType.toUpperCase() === 'SUV') {
      extraWashPrice = 10;
    } else if (this.props.details.carType.toUpperCase() === 'VAN') {
      extraWashPrice = 20;
    }    
    return (
      <div>
        {!this.state.error && !this.state.loading && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Welcome</h2>
            <br />
          <div style={styles.wrapper}>
              <TextField
                style={styles.field}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Name'}
                floatingLabelText={this.props.details.name ? 'name' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.name}
                onChange={(evt) => this.keyTyped('name', evt.target.value)}
                errorText={this.props.details.nameError ? 'Please fill in this field' : ''}
                maxLength={40}
              />
              <TextField
                style={styles.field}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Mobile Number'}
                floatingLabelText={this.props.details.phone ? 'Mobile Number' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.phone}
                onChange={(evt) => this.keyTyped('phone', evt.target.value.replace(/[^0-9\s]/g, ''))}
                errorText={this.props.details.phoneError ? 'Please fill in this field' : ''}
                maxLength={20}
              />
            <h3>Date and Time</h3>
            <div></div>
            <DatePicker
              mode={this.props.details.isSmallScreen ? 'portrait' : 'landscape'}
              hintText="Select Date"
              autoOk={true}
              formatDate={this.formatDate.bind(this)}
              shouldDisableDate={this.shouldDisableDate.bind(this)}
              style={styles.inputStyle}
              inputStyle={styles.inputStyle}
              textFieldStyle={styles.inputStyle}
              hintStyle={styles.hintStyle}
              floatingLabelText={this.props.details.date ? 'Date' : ''}
              value={this.props.details.date}
              onChange={(evt, date) => this.updateDate('date', date)}
              errorText={this.props.details.dateError ? 'Please select a date' : ''}
            />
            {this.state.startTimes &&
              < DropDownMenu
                value={this.props.details.startTime}
                style={{ width: '100%' }}
                onChange={this.handleStartTimeChange.bind(this)}
                autoWidth={false}
              >
                <MenuItem value={undefined} primaryText='Select Time' />
                {this.state.startTimes && this.state.startTimes.map((startTime) => {
                  return (
                    <MenuItem key={startTime} value={startTime} primaryText={this.format(startTime)} />
                  );
                })}
              </DropDownMenu>
            }
            <div style={styles.center}>
              <p style={{ paddingTop: 15 }}>Wash Type?</p>
              {this.props.details.washDetails &&
                <div style={styles.flexContainer}>
                  {washTypes.map((washType, idx) => {
                    return (
                      <Card
                        style={styles.cardContainer}
                        key={washType.name}
                      >
                        <h2 style={styles.cardTitle}>{washType.displayName}</h2>
                        <CardText
                          style={styles.subcard}
                        >
                          <ul style={styles.list}>
                            {washType.points.map((point, idx) => {
                              return (
                                <li key={idx} style={styles.li}>{point}</li>
                              );
                            })}
                          </ul>
                        </CardText>
                        {this.props.details.washDetails[washType.name].orginalPrice &&
                          <div style={styles.priceText} style={{ textDecoration: "line-through" }}>
                            ${(this.props.details.washDetails[washType.name].orginalPrice + (extraWashPrice)).toFixed(2)}
                          </div>
                        }  
                        <div style={styles.priceText}>
                          ${(this.props.details.washDetails[washType.name].cost + (extraWashPrice)).toFixed(2)}
                        </div>
                        <br/>
                        <RaisedButton
                          label="Book"
                          secondary={true}
                          style={styles.chooseButton}
                          onClick={this.confirmClicked.bind(this, washType.name)}
                          disabled={this.nextDisabled()}
                        />
                      </Card>
                    );
                  })}
                </div>
              }
            </div>
          </div>  
          </Card>
        }
        {this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Finished</h2>
            <CardText>
              <div>
                Thank you, your car wash has been booked! You will shortly receive payment instructions in your email.
            </div>
              <div>
                <RaisedButton
                  style={{ ...styles.button, ...{ marginTop: 40 } }}
                  label="Done"
                  primary={true}
                  onClick={this.refreshPage}
                />
              </div>
            </CardText>
          </Card>
        }
        {!this.state.error && this.state.loading && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Making your booking...</h2>
            <CardText>
              <CircularProgress />
            </CardText>
          </Card>
        }
        {this.state.error && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Error</h2>
            <CardText>
              <div>
                An error occurred.
            </div>
              <div>
                <RaisedButton
                  style={{ ...styles.button, ...{ marginTop: 40 } }}
                  label="Retry"
                  primary={true}
                  onClick={this.retry}
                />
              </div>
            </CardText>
          </Card>
        }
      </div>
    );
  }
}

export default Details;



// WEBPACK FOOTER //
// ./src/app/components/form/Details.js